import { OfferType as GqlOfferType } from '@occc-app/offerValidationService/types';
import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { ZodValidationError } from '@occc/ui-forms';

import { BaseEarnOfferSchema } from './schemas/base-earn/base-earn-offer.schema';
import { BaseEligibleEarnOfferSchema } from './schemas/base-eligible-earn/base-eligible-earn-offer.schema';
import { ExternalFulfillmentOfferSchema } from './schemas/external-fulfillment-offer.schema';
import { ProductPurchaseOfferSchema } from './schemas/product-purchase/product-purchase-offer.schema';
import { SpendBonusOfferSchema } from './schemas/spend-bonus/spend-bonus-offer.schema';
import { OfferConfigureFormValues, OfferType } from './types';

import { createRouteCreator } from '../CampaignComponents/utils';

export const routeCreator = createRouteCreator(GqlOfferType.Offer);

const validatorByOfferType: Record<OfferType, (value: unknown) => Promise<ZodValidationError>> = {
  [OfferType.ProductPurchase]: makeValidate(ProductPurchaseOfferSchema),
  [OfferType.SpendBonus]: makeValidate(SpendBonusOfferSchema),
  [OfferType.BaseEarn]: makeValidate(BaseEarnOfferSchema),
  [OfferType.BaseEligibleEarn]: makeValidate(BaseEligibleEarnOfferSchema),
  [OfferType.ExternalFulfillment]: makeValidate(ExternalFulfillmentOfferSchema),
};

export const validateConfiguration = async (values: OfferConfigureFormValues) => {
  if (values.offerType == null) {
    return;
  }

  return validatorByOfferType[values.offerType](values);
};
